import { useQuery } from "react-query";
import { getSeparationTypes } from "../../../../../actions/Employees";

export const useGetSeparationType = () => {
  return useQuery("GetSeparationTypes", getSeparationTypes, {
    refetchOnWindowFocus: false,
  });
};
